import * as Yup from 'yup';

export const validationSchema = () =>
  Yup.object({
    referenceNumber: Yup.string().required('Required').nullable(),
    description: Yup.string().required('Required').nullable(),
    currencyId: Yup.string().required('Required').nullable(),
  });
